import { useJson } from '@/hooks/useJson'

export interface InstructorArtist {
  id: string
  name: string
  image_url: string | null
  play_count: number
}

export interface ThemeCount {
  name: string
  count: number
}

export interface ThemeTile extends ThemeCount {
  image_url: string | null
}

export interface InstructorDetail {
  instructor: {
    id: string
    name: string
    image_url: string | null
    short_bio: string | null
  }
  totals: {
    rides: number
    rides_detailed: number
    unique_songs: number
    unique_artists: number
    avg_songs_per_ride: number
  }
  concentration: {
    top_artist_share_percent: number
    top_5_share_percent: number
  }
  top_artists: InstructorArtist[]
  genres: ThemeCount[]
  ride_types: ThemeCount[]
  themes: ThemeTile[]
}

export function useInstructorStats(id: string | undefined) {
  return useJson<InstructorDetail>(id ? `/api/instructors/${id}` : null, 'Failed to load instructor')
}
